module.exports = __webpack_public_path__ + "media/images/logo2_BACREA-b3b4ad819068d501b16e8ee56143d162.png";